export const STANDARD_HTTPS_PORT = 443;
export const DEVICE_NOT_FOUND = 'deviceNotFound';
export const DEVICE_NOT_SUPPORTED = 'deviceNotSupported';
export const HTTP_PROTOCOL_PREFIX = 'http://';
